'use client';
import { debounce } from 'lodash-es';
import React, { useCallback, useEffect, useRef } from 'react';

function Sticky(props) {
  const { children, offsetTop = 0, offsetBottom = 0, className = '' } = props;
  const stickyRef = useRef(null);

  const updateStickyPosition = useCallback(() => {
    const sticky = stickyRef.current;
    if (!sticky) return;

    const height = sticky.offsetHeight;
    const viewportHeight = window.innerHeight;
    const totalHeight = height + offsetTop + offsetBottom;

    const top =
      totalHeight < viewportHeight
        ? offsetTop
        : viewportHeight - height - offsetBottom;

    sticky.style.top = `${top}px`;
  }, [offsetTop, offsetBottom]);

  useEffect(() => {
    const handleResize = debounce(updateStickyPosition, 100);

    updateStickyPosition(); // Initial call

    window.addEventListener('scroll', updateStickyPosition, { passive: true });
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('scroll', updateStickyPosition);
      window.removeEventListener('resize', handleResize);
      handleResize.cancel(); // clean up debounce
    };
  }, [updateStickyPosition]);

  return (
    <div
      id="sticky"
      ref={stickyRef}
      style={{ top: `${offsetTop}px`, zIndex: 10 }}
      className={`sticky ${className}`}>
      {children}
    </div>
  );
}

export default React.memo(Sticky);
